import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface BusinessEmailAddressInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  label?: string;
}

export default function BusinessEmailAddressInput({
  value,
  onChange,
  disabled,
  label,
}: BusinessEmailAddressInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      inputProps={{ sx: { textTransform: 'lowercase' } }}
      label={label ? label : t('formInputs.businessEmailAddressInputLabel')}
      variant='outlined'
      fullWidth
      type='email'
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
